<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_title_bd') }}</span>
      </template>
    </navbar>
    <div class="content-devx transparent">
      <div class="flex-content home-grid">
        <a href="/climate/">
          <div class="dashboardItem">
            <img class="sizeDashboardItem climate">
            <span class="textDashboardItem">Clima</span>
          </div>
        </a>
        <a href="/crop/">
          <div class="dashboardItem">
            <img class="sizeDashboardItem crop">
            <span class="textDashboardItem">Cultivo</span>
          </div>
        </a>
        <a href="/floor/">
          <div class="dashboardItem">
            <img class="sizeDashboardItem floor">
            <span class="textDashboardItem">Suelo</span>
          </div>
        </a>
        <a
          v-if="selection === 'GreenHouse'"
          href="/irrigation/"
        >
          <div class="dashboardItem">
            <img class="sizeDashboardItem irrigation">
            <span class="textDashboardItem">Riego</span>
          </div>
        </a>
        <a
          v-else
          href="/fertilizers/"
        >
          <div class="dashboardItem">
            <img class="sizeDashboardItem fertilizers">
            <span class="textDashboardItem">Fertilizantes</span>
          </div>
        </a>
        <a href="/manure/">
          <div class="dashboardItem">
            <img class="sizeDashboardItem manure">
            <span class="textDashboardItem">Estiércol</span>
          </div>
        </a>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex';
import navbar from '../../components/navbar/NavBar.vue';

export default {
  name: 'Database',
  components: {
    navbar,
  },
  computed: {
    ...mapState('authentication', ['selection']),
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>

@import "./dataBase.scss";
@import "../../css/mixins";
.home-grid {
  padding: 0;
  @include md {
    padding-top: 96px;
    padding-bottom: 96px;
  }
  a {
    margin: 1rem;
    @include md {
      margin: 2rem;
    }
    width: 100%;
    @include md {
      width: auto;
    }
    display: flex;
    justify-content: center;
  }
}
</style>
